module.exports = __webpack_public_path__ + "866f35d470401101a4c4e406e4b21948.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/kampf_inactive.svg
// module id = 20
// module chunks = 0